// Share close completion between the product-page and upsell Size Guides.
(() => {
  const pending = new WeakMap();
  function close(drawer) {
    if (!drawer || !drawer.classList.contains('active')) return Promise.resolve();
    if (pending.has(drawer)) return pending.get(drawer);
    const panel = drawer.querySelector('.sg-panel');
    const overlay = drawer.querySelector('.sg-overlay');
    const cleanup = () => {
      drawer.classList.remove('active', 'sg-closing');
      panel?.style.removeProperty('--harven-guide-close-from');
      overlay?.style.removeProperty('--harven-guide-fade-from');
      pending.delete(drawer);
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cleanup();
      return Promise.resolve();
    }
    // Start from the current frame if Close is pressed during opening.
    panel?.style.setProperty('--harven-guide-close-from', getComputedStyle(panel).transform);
    overlay?.style.setProperty('--harven-guide-fade-from', getComputedStyle(overlay).opacity);
    drawer.classList.add('sg-closing');
    const animations = [panel, overlay].filter(Boolean).flatMap(element =>
      element.getAnimations().filter(animation =>
        animation.animationName === 'harven-guide-exit' ||
        animation.animationName === 'harven-guide-fade-out'
      )
    );
    const task = Promise.allSettled(animations.map(animation => animation.finished)).then(cleanup);
    pending.set(drawer, task);
    return task;
  }
  window.HarvenSizeGuideMotion = { close };
})();

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('sgDrawer');

  if (!drawer) return;

  const trigger = document.getElementById('sizeGuideTrigger');
  const closeBtn = drawer.querySelector('.sg-close');
  const overlay = drawer.querySelector('.sg-overlay');
  const cmBtn = document.getElementById('cmBtn');
  const inBtn = document.getElementById('inBtn');
  const cmTable = document.querySelector('.sg-table-cm');
  const inTable = document.querySelector('.sg-table-in');

  let closeTask = null;
  let previousOverflow = '';

  async function openDrawer() {
    if (closeTask) await closeTask;
    if (drawer.classList.contains('active')) return;
    previousOverflow = document.body.style.overflow;
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (closeTask) return closeTask;
    if (!drawer.classList.contains('active')) return;
    closeTask = window.HarvenSizeGuideMotion.close(drawer).then(() => {
      document.body.style.overflow = previousOverflow;
      closeTask = null;
    });
    return closeTask;
  }

  function toggleUnit(unit) {
    if (unit === 'cm') {
      cmTable.style.display = 'table';
      inTable.style.display = 'none';
      cmBtn.classList.add('active');
      inBtn.classList.remove('active');
    } else {
      inTable.style.display = 'table';
      cmTable.style.display = 'none';
      inBtn.classList.add('active');
      cmBtn.classList.remove('active');
    }
  }

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (cmBtn) {
    cmBtn.addEventListener('click', function () {
      toggleUnit('cm');
    });
  }

  if (inBtn) {
    inBtn.addEventListener('click', function () {
      toggleUnit('in');
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('sgDrawer');

  if (drawer && drawer.parentNode !== document.body) {
    document.body.appendChild(drawer);
  }
});

// Measurement controls are scoped to the clicked guide, including fetched upsell copies.
document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-sg-view-button], [data-sg-unit-button]');
  const drawer = button?.closest('.size-guide-drawer[data-sg-measurements]');
  if (!drawer) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (button.dataset.sgViewButton) drawer.dataset.sgMeasurements = button.dataset.sgViewButton;
  if (button.dataset.sgUnitButton) drawer.dataset.sgUnit = button.dataset.sgUnitButton;

  drawer.querySelectorAll('[data-sg-panel]').forEach(panel => {
    panel.hidden = panel.dataset.sgPanel !== drawer.dataset.sgMeasurements;
  });
  drawer.querySelectorAll('[data-sg-view-button]').forEach(control => {
    control.setAttribute('aria-pressed', String(control.dataset.sgViewButton === drawer.dataset.sgMeasurements));
  });
  drawer.querySelectorAll('[data-sg-unit-table]').forEach(table => {
    table.style.display = table.dataset.sgUnitTable === drawer.dataset.sgUnit ? 'table' : 'none';
  });
  drawer.querySelectorAll('[data-sg-unit-button]').forEach(control => {
    const active = control.dataset.sgUnitButton === drawer.dataset.sgUnit;
    control.classList.toggle('active', active);
    control.setAttribute('aria-pressed', String(active));
  });
}, true);
